import { useState } from 'react';
import { Button, Modal, ModalHeader, ModalFooter, ModalCloseButton, ModalDescription, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { StyledModalTitle } from '../add-seat-modal/add-seat-modal.styles';
import { CorpSideButton, StyledButtonIcon } from '../../corporate.styles';
import { BaseModalProps } from '../../corporate.types';
import { useEnableSSOMutation } from '../../corporate.slice';
export const EnableSSOModal = ({
  companyId,
  icon
}: BaseModalProps) => {
  const [enableSSO, {
    isLoading
  }] = useEnableSSOMutation();
  const [modalOpen, setModalOpen] = useState(false);
  const handleEnable = async () => {
    try {
      await enableSSO({
        companyId
      }).unwrap();
      NotificationDispatch('success', 'SSO Enabled Successfully');
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
  };
  return <Modal triggerElement={<CorpSideButton color="secondary">
          <StyledButtonIcon icon={icon} size="lg" />
          Enable SSO
        </CorpSideButton>} open={modalOpen} onOpenChange={open => setModalOpen(open)} preventOnOpenAutoFocus isSmall data-sentry-element="Modal" data-sentry-component="EnableSSOModal" data-sentry-source-file="enable-sso-modal.tsx">
      <ModalHeader isSmall data-sentry-element="ModalHeader" data-sentry-source-file="enable-sso-modal.tsx">
        <StyledModalTitle isSmall data-sentry-element="StyledModalTitle" data-sentry-source-file="enable-sso-modal.tsx">
          <FontAwesomeIcon icon={icon} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="enable-sso-modal.tsx" />
          Enable SSO
        </StyledModalTitle>
      </ModalHeader>
      <ModalDescription data-sentry-element="ModalDescription" data-sentry-source-file="enable-sso-modal.tsx">Are you sure you would like to enable SSO?</ModalDescription>
      <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="enable-sso-modal.tsx">
        <ModalCloseButton text="Close" data-sentry-element="ModalCloseButton" data-sentry-source-file="enable-sso-modal.tsx" />
        <Button color="primary" variant="solid"
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onClick={() => handleEnable()} disabled={isLoading} isLoading={isLoading} data-sentry-element="Button" data-sentry-source-file="enable-sso-modal.tsx">
          Yes, I&apos;m sure
        </Button>
      </ModalFooter>
    </Modal>;
};